export const UserStatus = {
  active: 'Active',
  inactive: 'Inactive',
} as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export class User {
  public id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public mobileNumber: string;
  public status: UserStatus;

  constructor(
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    mobileNumber: string | null,
    status: UserStatus
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.mobileNumber = mobileNumber || '';
    this.status = status;
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}
